{
  "v": "4.8.0",
  "meta": { "g": "LottieFiles AE 3.5.4", "a": "", "k": "", "d": "", "tc": "" },
  "fr": 30,
  "ip": 0,
  "op": 182,
  "w": 1000,
  "h": 1000,
  "nm": "Comp 1",
  "ddd": 0,
  "assets": [
    {
      "id": "image_0",
      "w": 500,
      "h": 500,
      "u": "",
      "p": "data:image/png;base64,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",
      "e": 1
    },
    {
      "id": "image_1",
      "w": 500,
      "h": 500,
      "u": "",
      "p": "data:image/png;base64,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",
      "e": 1
    },
    {
      "id": "image_2",
      "w": 500,
      "h": 500,
      "u": "",
      "p": "data:image/png;base64,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",
      "e": 1
    },
    {
      "id": "image_3",
      "w": 500,
      "h": 500,
      "u": "",
      "p": "data:image/png;base64,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",
      "e": 1
    },
    {
      "id": "image_4",
      "w": 500,
      "h": 500,
      "u": "",
      "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAH0CAYAAADL1t+KAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAAf1UlEQVR4nO3de2yl6V0f8N9zzvGxPZcdb5JdQjZ0B9KEAinrgESrBRTT/hF7UhSvisSlf+xEpahUSNmllQqqSiagAlUrZmhRxR+VMosqEijRTAq7dhAID7cCKuysSgglCcyGLMluSGLPzef6Pv3j2B7fr+d45pzz+Ugj2e95/bxPLvLXv+d9LhEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwP2Sr8xO5CuzE/e7H/AgSPe7AwCH1Xhh5lKk/L6IeClyWsgRC9X66EJ66uri/e4bHDeBDvStxtz09Yh4YpuP1gJ+9Nzc1ePuF9wPAh3oS8tz02fLEX+1z9uv5YiFUsTCyMz8Qi/7BfeLQAf6UuOFmWci5YuH/HEBz8AR6EBfas5NX80R7+lScwKevifQgb7UmJtejIgzPWr+uerM/PketQ09UbrfHQA4qOW56bOxLsyLRkT7bkRude0RT9dfmJntWmtwDCr3uwMAB1XKaTJSXvu+qHX+tSNi5HXpJ0qV/I05YiqOUMGnlC9FxI4z5BvPn5tMpWJfa+BzUVqsvvuF64ftC+yHQAf6T8qT67/NzZXLpWiNfufcj61ebzx/bjJSnkopTx0i4B9vzE2fr87MX97201JxNUc8vq+WSkU05qbXX3kpIhZTxGIRcT0iohSxEBHhHT6H5R060Hcac9MLEfHOiIjIEY0vdK6nkfj8ye+b/8odf+7gAf9ydWb+7OaLB1wydxhLEXE9croeETdSytcFPXsR6EDfacxN34iV6rhoRLRW9oUrVePaie+dn9pvO8256akiYipFnI+dq+33bq7Sj7hk7iheThHXc04LQp7NDLkD/WgtfNdPhEul+I2DNLISiAvNuemFHPFbO9x2ISIur7+wUuFHVMYjlU/s+ozcvhvRWj5It3bzeI54PFJ+T45YHca35I6IUKEDfaY5Nz21Pnzbtzsz3CMi0li8++R3z79wyHZ3W9e+oUpfXTKXTrwponJy94aLVuTbvRyd3+Ja5HQ1clowEW+4CHSgr9RfmJlNKV9Z/b755XuT4k49PX/o32l7vBd/eaQ2NpmeurrYeP7cZJSKFyMi0um3RKQ9Vv82b0ZefvWw3TqqlyOnq/a0Hw7WoQP9ZdMM9yhWLpeicZRmx2fmb0TEczt8/HhjrPZMREQuFZ316eXRvcM8InL3htsP4/FI+X0p5SuNuenFxtz0ZevrB5dAB/pKymnD2u/cXvmilO8ete1253359s+NeCZfmZ1IndnxkSqn9tdo6/ZRu9UtZyLi6ZVwv9F4YeZS4/lzk3v+FH1DoAP9ZV2FvhbmERGl+NxRm96jSj+zUqV3nl8Z37vBdj0iF0ftVi88Him/L0rFi4256euNuenz+crsvjbJ4cEl0IG+tT7QU6TXutHmHlX6v47VtevlfQR6Ue9Gl3rtiYj4YHOsdqMxN31Z1d6/BDrQb85udzGlqHWj8T2q9M44+36q87jv788P6kxEPL1StS805qbP3+8OcTACHeg3265BjxS/260HrFTpSzt9vtfa83sN9VWgr/fOiPjgyrv2ZwzH9weBDvSvvO7LUura7LPxmfkbOeLSjjeUR/duJBcRRbNbXbpfHo+ULzbHajfqc9MXBPuDTaADbKNaG7sUO1Xp+3l/3r/V+XbOpIj3C/YHm0AH2EZ66uritlV6aWRf68+j3RcT4g5KsD/ABDowGNr5891uctsqvbSP4fZY2cN9cK0G+3WT5x4cAh3oG8tz02d3+qy9HF0P9O2q9LSf9+cRg1qhb/Z4dCbPXW/OTU/d784MO4EO9I1yUdp+l7ge2lKl72fJWi4e1A1leuWJXU6r45gIdKBvbD49bD+vso8qPXV1Maf882sX9jPk3h8bynTbtfvdgWHnPHSgf607W600nv9uRCz04jGlnOZzxL+NVNrfXxH9taFMd+S061Gt+crsRHOsdilFTOScFhzv2n0CHRgIqVza52kpB5dzmoyU97f+PCLycbwLeMDkXf6Yas5NTzWjdjUizuSIiJTfEylHY256KUUsCPjuEOgAezsbEfue4T6MQ+7V+ujC5mv5yuxEc7R+IUd+3w4/diZHvEfAd4dAB9jLyglvKZX3d/9wzHBf7+X01NXF9RdWqvLLsW6r3n0Q8Ecg0IF+sxSrJ56t18rf0sNn7v/I1Ihhm+EesW64fR9V+UEI+AMQ6EC/uR6dw0NiU8H8ph4+c+UPiKHdIW4vCxERjefPTTZLtcvROZK1F7YP+Iir1Zn5yz16Zt+wbA3oX+t+g+UcPdmGdMOGKfuaFDd01XmM1Mau1uemL0SpeDF6F+bbOZMj3pMiZo/xmQ8sgQ70l52WR+V8kHe1vdP/J6wd1F80x2oLKeL9+7h3Kef0VHVmPqWI78gRH4gurF8vOqM2Q8+QO9BXcsqLq8vPS9V1HxRpn4eUH0wRMZUitr4/b9djrRpv19fem+dW105x7Rdv289NKeKjldrY+dXJcyMz8wux7t17c256auW/66lYeaWyX6Ue7T/QbwQ60F9yuh4pb71cRPXLH5ydePi9G2dbd027HvnWp4dxwttRLeWczlfPzV3d7aZdAn429hjGr9TGVOgh0IE+k3K6sT7Q00hEXhnlHj1VPx/bHXl6lOd1KkZBfjjX2hHnx8/N3TjoD64L+Av5yuxErVa7URRxplSNKG/cQuilzUvmhpV36EBf2bKf+/qZ7kVxoKFaemYpcnq2OjM/NT4zf+OojdWKxpl2I87kVkTR2PRhTgtHbX9QCHSgH720+sX6QM/t9M09eNbZHrQ5yK61Iyar5+a6NlKS28W/XP1682Z9u205O2wMuQP96HqsvFdNI/cu5lY81oNnPRiz5/tBTs92M8jXtOOfrX65KdCXRvd4Nz9MVOhAP1pY/WLDTPccpTu/NH3u+Lsz9F6KovSOXoT58kfOPV4046siOqMxaWMZKszXUaED/acoXY/SvUlq6yfGpcj/IiJe6MZj8pXZiWbUutHUwMoRHxidmb/Qq/aLZvHvY2UO5DZn4yz06rn9SIUO9J2ViXEvr36//hd9bqbv6NZzWmO1yW61NXBS/kQUpXf0MswjIko5vmvt67GNn43UxlTo6wh0oF8trH6xIdDbceb2L05/433ozzC5UZ3+2Nf3+nCU2q9Mn2s3OvvobzPc/pzlahsZcgf61UJEPB1x75d9bnU+KKX4kYj4vm4/MI09ElGdiCha98b4Izpr1Nv1yM2bw7H1a04/exyPKdrxk6tfb67Oc06q801U6EBf2jzcWl638WtuxT/tyUNXD2cpVSLK4/f+VU5GjL4uIrd78tgHTTvlnodpvjI7kZvx91e/3xToL5vdvpVAB/pSeurqYor46Or3pdGIWNnkPRdRvfPhd33/UZ9R5LT/E9yK1rDsJvdSNzaL2ctyq3Y5tzsZVRrdtIGQ6nxbAh3oW3n9sqW08V16yulHjvyAlDdOiiuP73BjRBRDcg56TpeP5THNePfq16XN5+Kk3P217gNAoAN9qzozfzkilla/L5+891nRiLcs//L0tx1bZ9rDEejHMdxe+8i7fjo3O3O8UnnjXgMp4qPHMULQjwQ60N/WVYypvPFda27H5a0/cEhp91+XeQgC/bjCtF1P71v9ev0faStU5zsQ6EBf2zz82rMqvbx1V5NNPenKYx5kxTEMt9f+18y/yc3o/FmWtk6GWzmFjW0IdKCvjc/M31g/OS6VN854L5px5Vg60lo+lsfcRz3fNz1fmZ0o7uS1pWrr/3dccaGXz+93Ah0YBFur9NUZ7614w93/OfPMfejTYDmG6ryRa5eKRnSO20lbAv3llTkT7ECgA31vZRj22tqFFFE5fe/zXMv/afkj5w58alqKuLGvG9sDX533fGb58tz02Vbt3qlq5ROx9kfZigu9fP4gEOjAQEibfuGXxu4drZqLqORm+8DDxRsCfZuTQYbItZ5PhluOX1qd2a46PxyBDgyElSr9ufXXKg/FWpVX1NPkUYbe04adTYZLzqmn1XlzbnqquBvfsvp95XSozg9BoAMDo935xb+2Lj2VNw69F8v5Zw4z9L6nwZ4Q19NtVvOV2YnW7bi6umvu5qWHoTrfN4EODIzxmfkbkdOF9ddKY+sCIkcqlotPHH/P+tqFXjbeqNR/pn23c6JaRET59MbPU8T5Xj5/kAh0YKBUz81divUT5KJTpa8evZnbMX73Q9Of2k9bldpYT48H7QNLvTxzvDk3PdW6ld+7+n1pdOOucBFxzbrz/RPowMBpd6q6taH3SBGVM3HvfXoj3nLnQ+/6s73aWX/edh6GY1E3yRGXenXmeL4yO9G6G3Nrp9CmiPKpjfe0VecHItCBgbMyI3vDBLhUjhh5+N73uZG+7s6Hp//7vhvNQxfoS9XaWM8mw9XLtSvt27H2trx8cuOJajniA/ZsPxiBDgyklYlUG2a9p8rKzPcVuR7//O6Hpn9xj6au7fH5QOpldV7/1ekfbd+KqdXv08iWZWovjc7MX+jFsweZQAcGVnVm/nxEvLT+WmlsY6gXjfje/b5T39Ge+7z3nZ5V58256an2nfjJ3Fq5kDb+7xEREUXpfC+ePegEOjDQRmpjU7F3qL/l7oemP7XdkrYcsdD5otj5IXucxNZvelWdN54/N9m6E/Prj46vnN461F599wvDPhnxUAbr/4UAm6Snri6uVHxL669vF+rFcvGJzaezpZw6wTYEx6Ou6El1nq/MTuR68RvtO7E2nLFhSWGHofYjEOjAwKu++4XrUZSmYo9Qz+0Yb9fit+/+8vRPrV5LKe9dLQ7QtrC9qM7zldmJRqn2h81b8frVa6mycdOfiFhqR8x287nDJu19C8BgaDx/bjJKxULEvY1MIiJyK6L55YjI966VRvP1NFKeHStVl5pjtS9HRKSTf2fH9+X55id71e3j9PJIbWyym4G+FuZL8ba1/35TxMjrNg215/RUr49nHXQqdGBorKvUN7xTT5XOkrbVzWciOnu/F3eLTy236ucj4osrV3duvDLe5d7eFxeOJcwf3vreXJgfnQodGDr5yuxEc6y2EBFPbPwgonUzotj0unzkdVGkSpTS6OsjRl+3fZvLr0Y0b/amw8fjperM/GS3GstXZifqpdr/aS3FW7aEeWXDrc+trEbgiFTowNBJT11dXAmv5zZ+0NlRrnwqNpQ7Ra3zu3K33eJSn1foadNGPEfReP7cZCPXPtVa3DPMXxqpjXXtucNOoANDa6UyfG9smixXPrExfNbWTG8u3dfr74lxz3Vrz/T6CzOz7TvFH6yfALdLmE/1avOaYSTQgaFWnZm/vON79dd1qvWiGZ0Jc+36zuvRy6MRpZEe97YnlrpVJdd/7V0/3VrMV9rL95amrW65K8x7zzt0gBX1uekLKeL9m6/ndkTkTiilk2+OKG8/vN6P79G7Mbt8eW76bGrE1dZSPLF+pUAaiRiZiM1JI8x7RIUOsGJ0Zv5CO+KrY9P+7am8bvi9eXvHn08jp3b87EGUIj561DCv/+r0j8at+PPW4sYwL59cOQxHmB8bFTrANuovzMymlC9FxMbtYMujnfXoO8i3Pr37NrEPjqWR2tjZw4Zr4/lzk+168eH27fjaDVX5ygE4m4bYI4R5zwl0gF005qbPR8SFWBfs6dRXR5S2JlZERK59IaLx4GfWYYfal+emz6Za/Hz7Trwrtzd+Vj7Z+bcNS9OOgUAH2IeVYP/PEfH6NPZIRHVi+xuLVuTbf3WMPTuUAwfs8tz02bgT/6Oox7euzfpfURrtTB5cv1nMmpyerZ6b69m56twj0AH2aWVDms9EefT0rsPudz8X0dr5Xft9dqCh79qVmR8omvmHcyO+dnNFnkY6FXmpuu2PLqWI2W4th2NvAh3gABpz05cj4und9nWP9nLkO589zm7t11IUpam9jietXZn5gdzM318045tyK7bU3XsEeaSIj1ZqY+e9Lz9e278EAmB7RelSlIqnc2Mx0vhXbH9PeTyicuqBq9JzTudHN4V5vjI7UWstf1eO9E+iFd+U2/FY62beugIqrQytn9xhaL1jKed0vmpf9vtChQ5wQI256YWIeOduk+MetHfpuRUfb9+Ov42IyCk/Gu34yoh0Irdihzq7ozR679+uiZHTz47UR7t6uAsHo0IHOKAUcSFH/Fauf3HnKr1UiTT6+sj1Lx5v57ZR1CJaN+Mb7l3ZJZlTZyh9XyHe8Vw74sL4ubkbR+4oR6JCBziE5tz01Rzxnl2r9IjIdz7T2TL2PinqEa2lnT9f3TQnjXSCfJv14zvpBPnM/I2j95JuEOgAh7A8N322HPFXURmPdOLNO9/YrndC/T7IrZXX+Csbv6TyvX9RWtl6/mApsBQ5XW6nfEmQP3gEOsAhre79vuu69IjINz95jL3quqWIuJpzunrUbWLpLYEOcASNuenrEfHEbsvY+jDQX4qcFnLEghDvHybFARxBO2K2HHE93/3smXTy8a3v0+/j+/N9eDkibkTEjcjpekr5uo1g+pcKHeCIVg5yuRLl0Ujjb9oY6q3lyHePaZOZnD6YUv6FvW4T2oNJoAN0wcpe7x+MVOpMklsdfj+eQF+KiGeqM/OXe/0gHlzOQwfogpUwfW/kojOrvf6liIjI7bu9fvRLUZSmhDkqdIAuWqvUIzrrwlIlor3ck2fliA+Mzsxf6Enj9B2BDtBljefPTUapuBrrzlDvsmtRlJ7Z65AVhotAB+iBfGV2ojlavxApv29fP5AqESlFFM3d7rqWIi6Y1MZ2BDpAjzTnpqdyxG91oannUsRlQc5urEMH6JEiYuqQVdNLEXE953S1Wh9dcIIZ+yHQAXokRcwe4N7vaEXcsEc6h2XIHaAH1g5v2Z9r1Zn5qV72h8FnHTpAD5Qizu/33hyx0LueMCwEOkAPpIhnDnDvjR52hSEh0AG6bGVzmTP7vV+g0w0CHaCL8pXZiYi4cJCfqdTGbBDDkQl0gC5qjNWeiQPuEGdZGt0g0AG6pPH8uckU8f773Q+Gk3XoAHtYnps+W8ppMlKeXH895bSYUr4e0Rk2b5Zql+9LByEEOsCulj489T3liA9Fyls/TDlWrzbHasfaL9jMkDvALm69dutHev2M5bnps71+BoNPoAPs4JM/8fap5cXlJ5b+Zqmnz6lEnO3pAxgKAh1gJzlfiIhYfGUpXv3z16LVaEVRdH/H7BzxXV1vlKFjL3eAbXzyJ94+FbnYcPRp5fSjUT71+hgda8VDE80oV4puPvLlyOnSSH30smVsHIZAB9jGJ3/8GxYi8jvXLpTKMfroWyNSee1SudyMiTc0YmSkq8G+lCMuVWtjlwQ7ByHQATbZuTp/ZMu97Zt/EydOteLkG05G9US1m91YipwuVM/NXepmowwugQ6wySd//OtvxLrd3lJ5JKqPvm3LfbndjMZrf7H2fWW0EicmxmP0obE4MTHere5cG6mNzarW2Yt16MBQ+qG3n5qKiKmIPLX++jve+tAbY9PWreXTj27bRvvWaxu+b9VbcfPVWxGv3oqIiLHTYzH20GiMnh6LsdOjh+3qOxuVuz8YET912AYYDgIdGDr/7ptP/eJSPX/vdp+942tPb/g+lUeiPD6x9cbcjnb91q7Pqd2qRe1WLSI6y96qJ6pRPTES1RPVGFn5ulTefbFR0S7i5udvPrHrTRACHRhCJyvpHy3Vt9n5LSJOn9j4a7Ey8di297XvfCmiaB/ouY27jWjcbUTEnQ3Xqyeqa8FeGS1HZbQStZv1tZ8pWsWfH+hBDCWBDgyVi0+ePp9S+opHx0vx2vLW2emfuHE7vu7sqYiIKFVPRql6cmsjuR2tO1/sWp86Ib9i96IfdmRjGWDIlM5HRDxUTfFVp0oxWt44N/jX/+iL8Ycf7wyRl09vndUecbjqHHpNoAND4+K3TUyldG9t+Wi5E+qPjpeisu634R98fDE++Pwr0Whus768y9U5dItAB4ZHLs5vd/mhaoqzp8vx6HgpTlQ7byJv3mnFf/nvvxO/+Zsvxu2bN9fubd9dVJ3zQPIOHRgKF//hxNkUxdO73fNQNcWjZx6OerMdf3vrbty8W48//tPPxR//6efisTeejn/8bW+N0daXo7v7x0B3CHRgOJSKZ/a6pVwdjZRSjFUr8ebXPxTth3PcvFuPm8v1eOXzt+IXfuVPIiLiLY+diLc8Nh5f89iJGB0x0MmDQaADA+/i1MREqVWcz9uvVFtTGdm4+Uu5lOLhU2Px8KmxaBc5vnx7Oe7Um/HpV+7Gp1+5GxFfXAv3Nz86tmXJW7e8/OryZE8aZqCU974FoL9Nv2nkeyLSd+92TyqVYuTENkvUVpRSihOjI3G6WorTqRkjpRSRIr6w1IxPvbIcL/7FrfjLV5bjy7da0W7nODFejkq5O7tr/+5Li3/vrePpvf/gK6qLf/Ra83pXGmXg2MsdGHgXv/WhG2nTdq6bVcbGY2TsxJ5tNe7cinazseHacivHnVaO5VZEvX1vGOCRiWq8+dGxeGRiJB6ZqMYbJg738v0jC6/GZ1+rrX77UpHj/H/7+B3BzgYCHRhoF7/99Gwq0pW97hs9/fCe27DmnKO29KVd7ylyJ+CX21sDPiLizY+OxehIKR6ZqMZDJ8vx0MnOMP1jj4xtuO9vFxtx804rPv3KcvzZjdubH3Mnpfih//p/71ze6z8Xw0OgAwPt4pNnFtavPd9OqTISo6ce2rOtVr0WzeU7e9632XIrx3IrR73oBHyrO8en50pl5HWXri86hY2IEOjAALv45MRkSsWLe91XPXEqytW9T0Or31qKot06cr+K3An2ejviTrNTzR/Gz/3pHb/DWWOWOzC40t5L1SKlfYV50W51JcwjIkopYrySYrwSUS9yhH1q6AILKIGBdHFqYiJF7LqRTEREeWR/E9Va9dreNx1CQ5jTJQIdGEytfVTnEVEZHdv7pogtM9u7ZfOkuf0aLSfvztlAoAMDqRSxZ6CXypUolfd+89hu1CP22pXmEJZb3W+T4SXQgYFz8cnT53OOM3vdt5935xERrUb9yH3aTv1ow+3deaHPwBDowADqnHm+l/1NhiuiaDWP2qFt1YvDV+gjpfh4F7vCABDowMDZa915RGcyXEp7r/pqN3szGS7ChDi6S6ADQ2m/w+3tHg23Rxx+QlxERI7o3V8a9CWBDgycHPHcbp+nUmlfy9XazUbkojvbum121AlxlZTnu9QVBoRABwZPu3QhpVja6eP9rj3v1VK1CDPc6T6BDgycZ/9g8UZRlKZ2CvVydXzPNnLOvR1u703hzxCzDzAwsC4+OTFZKhUL65ew7fcglnajHo27W04565obt9pHOqTFPu5spkIHBtazv794vaiUzuacrq1eq+x37XmPtnqN6BzO0qUT12CNQAcG2rMLi4vP/v7SVI54NqVYKu3j/Xk3D2LZzlFmt8NOBDowFJ79vZuX2u34mtxuz+11by/fnUccfULcSCn37l0AfUugA0Pjh//3zS/94Mf++lyz1X570W5/bKf7erXV66qjTogrpZJtX9lCoAND54c+9pmP/+D8Z6Zrt26/rd1s/lped/BKrw5iWc+QO70g0IGh9b7f/sIn/9Wvf/Y7l+8uPtxq1H+uaDdf6+Xa84juTIirpPz/utMbBollDwDrXPz207NRpNkU8XQv2l9u5XjlztES/dRIuvbTL96e6k6PGBQqdIB1nv2dW1ef/b2b5/NI6eGc83tzxEe72X43dogrl+JvutAVBowKHWAPF6cmJqLdnooizUbEVIp4/LBtfe5uEXeaRwv1M9X0Pf/hT27/0pEaYeAIdIADuvjkxGSkYioipkopptbvRLeXo+4Qd3IkvfofX7z9xsO3wKAS6ABHdPHJicmI9mREmoxIkzudx17kiL+8ebhD0Esp8olK+m3vztmJQAfogYtPTkxGuX02cpqMHGcjp7P1ovjKLyznt+1n2VqlFFFJ6XalFH9dKcVvvP505ceeXVhcPIau06cEOsB9cHFqYiJaMRkRcavZemNExOmRyucjIp793cWF+9g1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALhf/j/MkSm/ciSMJQAAAABJRU5ErkJggg==",
      "e": 1
    },
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Shape Layer 6",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 33,
                  "s": [0]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 47,
                  "s": [-13]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 67,
                  "s": [-13]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 77,
                  "s": [35]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 127,
                  "s": [35]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 137,
                  "s": [-13]
                },
                { "t": 154, "s": [0] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 0,
                  "s": [526, 500, 0],
                  "to": [-7.667, 0, 0],
                  "ti": [3.5, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 18,
                  "s": [480, 500, 0],
                  "to": [-3.5, 0, 0],
                  "ti": [-6.667, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [505, 500, 0],
                  "to": [6.667, 0, 0],
                  "ti": [-2.5, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 33,
                  "s": [520, 500, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [520, 500, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [520, 500, 0],
                  "to": [1.917, 6.625, 0],
                  "ti": [-1.917, -6.625, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [531.5, 539.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [531.5, 539.75, 0],
                  "to": [-0.25, -6.625, 0],
                  "ti": [5.25, 6.625, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 137,
                  "s": [530, 500, 0],
                  "to": [-5.25, -6.625, 0],
                  "ti": [0.667, 0, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 154,
                  "s": [500, 500, 0],
                  "to": [-0.667, 0, 0],
                  "ti": [-4.333, 0, 0]
                },
                { "t": 178, "s": [526, 500, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 0,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [-5.25, -16.5],
                              [-7.25, -3.75]
                            ],
                            "c": false
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 18,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [22, -18],
                              [26, 2]
                            ],
                            "c": false
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 33,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [-5.25, -16.5],
                              [-7.25, -3.75]
                            ],
                            "c": false
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 137,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [-5.25, -16.5],
                              [-7.25, -3.75]
                            ],
                            "c": false
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 154,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [22, -18],
                              [26, 2]
                            ],
                            "c": false
                          }
                        ]
                      },
                      {
                        "t": 178,
                        "s": [
                          {
                            "i": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "o": [
                              [0, 0],
                              [0, 0],
                              [0, 0]
                            ],
                            "v": [
                              [-51, -16],
                              [-5.25, -16.5],
                              [-7.25, -3.75]
                            ],
                            "c": false
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.105882360421, 0.090196078431, 0.090196078431, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 18476,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 2,
          "nm": "Layer 11",
          "refId": "image_0",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 37,
                  "s": [16]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 47,
                  "s": [16]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 67,
                  "s": [16]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 77,
                  "s": [38]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 127,
                  "s": [38]
                },
                { "t": 137, "s": [16] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 0,
                  "s": [440, 427, 0],
                  "to": [-7.833, 0, 0],
                  "ti": [0.333, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 18,
                  "s": [393, 427, 0],
                  "to": [-0.333, 0, 0],
                  "ti": [-8.604, -1.333, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [438, 427, 0],
                  "to": [8.604, 1.333, 0],
                  "ti": [1.667, -2.5, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 37,
                  "s": [444.625, 435, 0],
                  "to": [-1.667, 2.5, 0],
                  "ti": [-0.333, -0.167, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 47,
                  "s": [428, 442, 0],
                  "to": [0.211, 0.105, 0],
                  "ti": [0, 0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 52,
                  "s": [428, 452, 0],
                  "to": [0, -0.833, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 57,
                  "s": [428, 437, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 62,
                  "s": [428, 442, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [428, 442, 0],
                  "to": [9.875, -3.375, 0],
                  "ti": [-9.875, 3.375, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [487.25, 421.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [487.25, 421.75, 0],
                  "to": [-8.208, 3.375, 0],
                  "ti": [13.208, -0.875, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 137,
                  "s": [438, 442, 0],
                  "to": [-13.208, 0.875, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 154,
                  "s": [408, 427, 0],
                  "to": [0, 0, 0],
                  "ti": [-5.333, 0, 0]
                },
                { "t": 178, "s": [440, 427, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [262.5, 194, 0], "ix": 1 },
            "s": { "a": 0, "k": [89, 89, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 3598,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 2,
          "nm": "Layer 16",
          "refId": "image_1",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 72,
                  "s": [29]
                },
                { "t": 77, "s": [39] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 72,
                  "s": [380.906, 474.629, 0],
                  "to": [1.667, -5.25, 0],
                  "ti": [-1.667, 5.25, 0]
                },
                { "t": 77, "s": [390.906, 443.129, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [260.558, 209.423, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 72,
          "op": 127,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 2,
          "nm": "Layer 15",
          "refId": "image_2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 72,
                  "s": [42]
                },
                { "t": 77, "s": [49] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 72,
                  "s": [447.254, 480.518, 0],
                  "to": [3.583, -2.917, 0],
                  "ti": [-3.583, 2.917, 0]
                },
                { "t": 77, "s": [468.754, 463.018, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [192.703, 232.314, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 72,
          "op": 127,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "Shape Layer 12",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [2]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [28]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [28]
                },
                { "t": 137, "s": [2] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 26,
                  "s": [430.25, 488, 0],
                  "to": [-7.667, 0, 0],
                  "ti": [1.833, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 44,
                  "s": [384.25, 488, 0],
                  "to": [-1.833, 0, 0],
                  "ti": [-8.333, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 53,
                  "s": [419.25, 488, 0],
                  "to": [8.333, 0, 0],
                  "ti": [-0.833, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 59,
                  "s": [434.25, 488, 0],
                  "to": [0.833, 1.667, 0],
                  "ti": [1.667, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 73,
                  "s": [424.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 93,
                  "s": [424.25, 498, 0],
                  "to": [6.833, -5.042, 0],
                  "ti": [-6.833, 5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 103,
                  "s": [465.25, 467.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [465.25, 467.75, 0],
                  "to": [-5.167, 5.042, 0],
                  "ti": [5.167, -5.042, 0]
                },
                {
                  "i": { "x": 0.755, "y": 0.646 },
                  "o": { "x": 0.312, "y": 0 },
                  "t": 137,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [11.386, 2.277, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.403, "y": 0.658 },
                  "t": 154,
                  "s": [402.771, 488.704, 0],
                  "to": [-2.205, -0.441, 0],
                  "ti": [-6.747, 0.784, 0]
                },
                { "t": 178, "s": [443.25, 484, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [78, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [78, 91, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [78, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [78, 91, 100]
                },
                {
                  "i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 137,
                  "s": [78, 78, 100]
                },
                { "t": 178, "s": [78, 78, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 127,
          "op": 3624,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "Shape Layer 11",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [2]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [28]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [28]
                },
                { "t": 137, "s": [2] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 26,
                  "s": [430.25, 488, 0],
                  "to": [-7.667, 0, 0],
                  "ti": [1.833, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 44,
                  "s": [384.25, 488, 0],
                  "to": [-1.833, 0, 0],
                  "ti": [-8.333, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 53,
                  "s": [419.25, 488, 0],
                  "to": [8.333, 0, 0],
                  "ti": [-0.833, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 59,
                  "s": [434.25, 488, 0],
                  "to": [0.833, 1.667, 0],
                  "ti": [1.667, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 73,
                  "s": [424.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 93,
                  "s": [424.25, 498, 0],
                  "to": [6.833, -5.042, 0],
                  "ti": [-6.833, 5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 103,
                  "s": [465.25, 467.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [465.25, 467.75, 0],
                  "to": [-5.167, 5.042, 0],
                  "ti": [5.167, -5.042, 0]
                },
                {
                  "i": { "x": 0.755, "y": 0.646 },
                  "o": { "x": 0.312, "y": 0 },
                  "t": 137,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [11.386, 2.277, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.403, "y": 0.658 },
                  "t": 154,
                  "s": [402.771, 488.704, 0],
                  "to": [-2.205, -0.441, 0],
                  "ti": [-6.747, 0.784, 0]
                },
                { "t": 178, "s": [443.25, 484, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [88, 10, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [88, 101, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [88, 10, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [88, 101, 100]
                },
                {
                  "i": { "x": [0.833, 0.833, 0.833], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 137,
                  "s": [88, 88, 100]
                },
                { "t": 178, "s": [88, 88, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 127,
          "op": 3624,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "Shape Layer 5",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [2]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [28]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [28]
                },
                { "t": 111, "s": [2] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 0,
                  "s": [443.25, 484, 0],
                  "to": [-9.833, 0.667, 0],
                  "ti": [4, -0.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 18,
                  "s": [384.25, 488, 0],
                  "to": [-4, 0.667, 0],
                  "ti": [-8.333, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [419.25, 488, 0],
                  "to": [8.333, 0, 0],
                  "ti": [-0.833, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [434.25, 488, 0],
                  "to": [0.833, 1.667, 0],
                  "ti": [1.667, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [424.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [424.25, 498, 0],
                  "to": [6.833, -5.042, 0],
                  "ti": [-6.833, 5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [465.25, 467.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [465.25, 467.75, 0],
                  "to": [-5.167, 5.042, 0],
                  "ti": [5.167, -5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 111,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 132,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [-1.5, 2.333, 0]
                },
                { "t": 142, "s": [443.25, 484, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [78, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [78, 91, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 67,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 72,
                  "s": [78, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [78, 91, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [78, 78, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [78, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [78, 91, 100]
                },
                { "t": 132, "s": [78, 78, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 72,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "Shape Layer 3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [2]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [28]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [28]
                },
                { "t": 111, "s": [2] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 0,
                  "s": [443.25, 484, 0],
                  "to": [-9.833, 0.667, 0],
                  "ti": [4, -0.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 18,
                  "s": [384.25, 488, 0],
                  "to": [-4, 0.667, 0],
                  "ti": [-8.333, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [419.25, 488, 0],
                  "to": [8.333, 0, 0],
                  "ti": [-0.833, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [434.25, 488, 0],
                  "to": [0.833, 1.667, 0],
                  "ti": [1.667, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [424.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [424.25, 498, 0],
                  "to": [6.833, -5.042, 0],
                  "ti": [-6.833, 5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [465.25, 467.75, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [465.25, 467.75, 0],
                  "to": [-5.167, 5.042, 0],
                  "ti": [5.167, -5.042, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 111,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 132,
                  "s": [434.25, 498, 0],
                  "to": [0, 0, 0],
                  "ti": [-1.5, 2.333, 0]
                },
                { "t": 142, "s": [443.25, 484, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [88, 10, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [88, 101, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 67,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 72,
                  "s": [88, 10, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [88, 101, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [88, 88, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [88, 10, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [88, 101, 100]
                },
                { "t": 132, "s": [88, 88, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 72,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 9,
          "ty": 2,
          "nm": "Layer 14",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 0,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 20,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 40,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 50,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 74,
                  "s": [-4]
                },
                { "t": 84, "s": [-20] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": -10,
                  "s": [382.5, 450, 0],
                  "to": [-3.333, 0, 0],
                  "ti": [7.5, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 0,
                  "s": [362.5, 450, 0],
                  "to": [-7.5, 0, 0],
                  "ti": [0.833, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 10,
                  "s": [337.5, 450, 0],
                  "to": [-0.833, 1.667, 0],
                  "ti": [-3.333, -3.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 20,
                  "s": [357.5, 460, 0],
                  "to": [3.333, 3.333, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 25,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 30,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 35,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 40,
                  "s": [357.5, 460, 0],
                  "to": [5.833, -8.792, 0],
                  "ti": [-5.833, 8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 50,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 54,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 59,
                  "s": [392.5, 417.25, 0],
                  "to": [0, -0.833, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 64,
                  "s": [392.5, 402.25, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 69,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 74,
                  "s": [392.5, 407.25, 0],
                  "to": [-5.833, 8.792, 0],
                  "ti": [5.833, -8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 84,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 90,
                  "s": [357.5, 460, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 95,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 100,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                { "t": 105, "s": [357.5, 460, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [387, 224, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 96.246, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 11,
          "st": -10,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 10,
          "ty": 2,
          "nm": "Layer 17",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 50,
                  "s": [-6]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 64,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 84,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 94,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 144,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.586], "y": [0.719] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 154,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.349], "y": [-0.281] },
                  "t": 165,
                  "s": [-9.86]
                },
                { "t": 178, "s": [-20] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 34,
                  "s": [382.5, 450, 0],
                  "to": [-7.5, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 44,
                  "s": [337.5, 450, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.333, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 50,
                  "s": [352.5, 450, 0],
                  "to": [3.333, 1.667, 0],
                  "ti": [-0.833, -3.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 64,
                  "s": [357.5, 460, 0],
                  "to": [0.833, 3.333, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 69,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 74,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 79,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 84,
                  "s": [357.5, 460, 0],
                  "to": [5.833, -8.792, 0],
                  "ti": [-5.833, 8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 94,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 144,
                  "s": [392.5, 407.25, 0],
                  "to": [-5.833, 8.792, 0],
                  "ti": [9.25, -7.125, 0]
                },
                {
                  "i": { "x": 0.581, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 154,
                  "s": [357.5, 460, 0],
                  "to": [-9.25, 7.125, 0],
                  "ti": [-0.833, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 165,
                  "s": [337, 450, 0],
                  "to": [0.833, -1.667, 0],
                  "ti": [-4.25, 0, 0]
                },
                { "t": 178, "s": [362.5, 450, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [387, 224, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 96.246, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 165,
          "op": 3615,
          "st": 34,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 11,
          "ty": 2,
          "nm": "Layer 13",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 33,
                  "s": [-6]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 47,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 67,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 77,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 127,
                  "s": [-4]
                },
                { "t": 137, "s": [-20] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 17,
                  "s": [382.5, 450, 0],
                  "to": [-7.5, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [337.5, 450, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.333, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [352.5, 450, 0],
                  "to": [3.333, 1.667, 0],
                  "ti": [-0.833, -3.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 47,
                  "s": [357.5, 460, 0],
                  "to": [0.833, 3.333, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 52,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 57,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 62,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [357.5, 460, 0],
                  "to": [5.833, -8.792, 0],
                  "ti": [-5.833, 8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [392.5, 407.25, 0],
                  "to": [-5.833, 8.792, 0],
                  "ti": [9.167, -7.125, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 137,
                  "s": [357.5, 460, 0],
                  "to": [-9.167, 7.125, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 148,
                  "s": [337.5, 450, 0],
                  "to": [0, 0, 0],
                  "ti": [-4.167, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 158,
                  "s": [357.5, 460, 0],
                  "to": [4.167, 0, 0],
                  "ti": [-0.833, 1.667, 0]
                },
                { "t": 168, "s": [362.5, 450, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [387, 224, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 96.246, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 27,
          "op": 148,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 12,
          "ty": 4,
          "nm": "Shape Layer 10",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 40,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 50,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 74,
                  "s": [19]
                },
                { "t": 84, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": -10,
                  "s": [388, 496, 0],
                  "to": [-1.667, -0.667, 0],
                  "ti": [6.667, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 0,
                  "s": [378, 492, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [1.5, -2, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 10,
                  "s": [348, 496, 0],
                  "to": [-1.5, 2, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 20,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 40,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 50,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 74,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                { "t": 84, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 20,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 25,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 30,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 35,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 54,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 59,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 64,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 69,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 90,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 95,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 100,
                  "s": [50, 68, 100]
                },
                { "t": 105, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 11,
          "st": -10,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 13,
          "ty": 4,
          "nm": "Shape Layer 18",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [19]
                },
                { "t": 137, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0.194 },
                  "t": 165,
                  "s": [347.991, 495.909, 0],
                  "to": [3.772, -0.288, 0],
                  "ti": [-5.002, 0.651, 0]
                },
                { "t": 178, "s": [378, 492, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [50, 68, 100]
                },
                { "t": 137, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 165,
          "op": 3624,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 14,
          "ty": 4,
          "nm": "Shape Layer 14",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [19]
                },
                { "t": 137, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 43,
                  "s": [388, 496, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 53,
                  "s": [348, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 59,
                  "s": [358, 496, 0],
                  "to": [3.5, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 73,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 93,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 103,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 137,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 148,
                  "s": [348, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 168, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 137,
                  "s": [50, 50, 100]
                },
                { "t": 168, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 127,
          "op": 148,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 15,
          "ty": 4,
          "nm": "Shape Layer 17",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [19]
                },
                { "t": 137, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0.195 },
                  "t": 165,
                  "s": [348.116, 495.909, 0],
                  "to": [3.772, -0.288, 0],
                  "ti": [-4.981, 0.651, 0]
                },
                { "t": 178, "s": [378, 492, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [61, 79, 100]
                },
                { "t": 137, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 165,
          "op": 3624,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 16,
          "ty": 4,
          "nm": "Shape Layer 13",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 93,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 103,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [19]
                },
                { "t": 137, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 43,
                  "s": [388, 496, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 53,
                  "s": [348, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 59,
                  "s": [358, 496, 0],
                  "to": [3.5, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 73,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 93,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 103,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 137,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 148,
                  "s": [348, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 168,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [-1.5, 2, 0]
                },
                { "t": 178, "s": [378, 492, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 73,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 78,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 83,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 88,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 107,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 132,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 137,
                  "s": [61, 61, 100]
                },
                { "t": 168, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 127,
          "op": 148,
          "st": 43,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 17,
          "ty": 4,
          "nm": "Shape Layer 8",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [19]
                },
                { "t": 111, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 17,
                  "s": [388, 496, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [348, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [358, 496, 0],
                  "to": [3.5, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 77,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 111,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 132,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [-1.5, 2, 0]
                },
                { "t": 142, "s": [378, 492, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 67,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 72,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [50, 68, 100]
                },
                { "t": 132, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 27,
          "op": 72,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 18,
          "ty": 4,
          "nm": "Shape Layer 9",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 40,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 50,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 74,
                  "s": [19]
                },
                { "t": 84, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": -10,
                  "s": [388, 496, 0],
                  "to": [-1.667, -0.667, 0],
                  "ti": [6.667, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 0,
                  "s": [378, 492, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [1.5, -2, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 10,
                  "s": [348, 496, 0],
                  "to": [-1.5, 2, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 20,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 40,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 50,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 74,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [5.792, -8.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 84,
                  "s": [369, 504, 0],
                  "to": [-5.792, 8.833, 0],
                  "ti": [1.667, 0.667, 0]
                },
                { "t": 142, "s": [359, 500, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 20,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 25,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 30,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 35,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 54,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 59,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 64,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 69,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 90,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 95,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 100,
                  "s": [61, 79, 100]
                },
                { "t": 105, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 11,
          "st": -10,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 19,
          "ty": 4,
          "nm": "Shape Layer 7",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [19]
                },
                { "t": 111, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 17,
                  "s": [388, 496, 0],
                  "to": [-6.667, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.176, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 27,
                  "s": [348, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.5, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [358, 496, 0],
                  "to": [3.5, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 77,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 111,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 132,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [-1.5, 2, 0]
                },
                { "t": 142, "s": [378, 492, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 67,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 72,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [61, 79, 100]
                },
                { "t": 132, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 27,
          "op": 72,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 21,
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 33,
                  "s": [-2]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 47,
                  "s": [-3]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 67,
                  "s": [-3]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 77,
                  "s": [11]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 127,
                  "s": [11]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 137,
                  "s": [-3]
                },
                {
                  "i": { "x": [0.833], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 154,
                  "s": [1]
                },
                { "t": 169, "s": [-2] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [459.5, 626, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 67,
                  "s": [459.5, 626, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [459.5, 626, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 127,
                  "s": [459.5, 626, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 137, "s": [459.5, 626, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [23.5, 156.928, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 99.09, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 0,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-64.869, -43.468],
                              [-5.75, 2.626],
                              [0, 0],
                              [28.919, 140.303],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [101.681, -39.719],
                              [-74.372, -65.26],
                              [-78.372, -55.901],
                              [-78.122, -51.07],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [106.431, -31.733]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 17,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-71.5, -35.948],
                              [-5.75, 2.626],
                              [0, 0],
                              [10.5, 146.877],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [79.75, -49.328],
                              [-79.75, -61.663],
                              [-83.75, -52.304],
                              [-83.5, -47.472],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [84.5, -41.341]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 27,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-64.869, -43.468],
                              [-5.75, 2.626],
                              [0, 0],
                              [28.919, 140.303],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [101.681, -39.719],
                              [-74.372, -65.26],
                              [-78.372, -55.901],
                              [-78.122, -51.07],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [106.431, -31.733]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 137,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-64.869, -43.468],
                              [-5.75, 2.626],
                              [0, 0],
                              [28.919, 140.303],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [101.681, -39.719],
                              [-74.372, -65.26],
                              [-78.372, -55.901],
                              [-78.122, -51.07],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [106.431, -31.733]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 154,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-71.5, -35.948],
                              [-5.75, 2.626],
                              [0, 0],
                              [10.5, 146.877],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [79.75, -49.328],
                              [-79.75, -61.663],
                              [-83.75, -52.304],
                              [-83.5, -47.472],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [84.5, -41.341]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "t": 169,
                        "s": [
                          {
                            "i": [
                              [0, 0.25],
                              [7.024, -3.207],
                              [0, 0],
                              [-0.125, -0.25],
                              [0.063, -0.063],
                              [0, 0],
                              [-5.25, 0.063],
                              [0, 0.5],
                              [-2.5, 6.525]
                            ],
                            "o": [
                              [-64.869, -43.468],
                              [-5.75, 2.626],
                              [0, 0],
                              [28.919, 140.303],
                              [5.875, 5.474],
                              [0, 0],
                              [5.25, -0.063],
                              [17, -94.734],
                              [2.417, -6.308]
                            ],
                            "v": [
                              [101.681, -39.719],
                              [-74.372, -65.26],
                              [-78.372, -55.901],
                              [-78.122, -51.07],
                              [0.625, 151.454],
                              [13.25, 158.38],
                              [30.25, 158],
                              [36.5, 152.257],
                              [106.431, -31.733]
                            ],
                            "c": true
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "gf",
                  "o": { "a": 0, "k": 100, "ix": 10 },
                  "r": 1,
                  "bm": 0,
                  "g": {
                    "p": 3,
                    "k": {
                      "a": 0,
                      "k": [
                        0, 0.871, 0.831, 0.91, 0.71, 0.62, 0.545, 0.747, 1,
                        0.369, 0.259, 0.584
                      ],
                      "ix": 9
                    }
                  },
                  "s": { "a": 0, "k": [-80, 19.991], "ix": 5 },
                  "e": { "a": 0, "k": [82.5, 72.588], "ix": 6 },
                  "t": 1,
                  "nm": "Gradient Fill 1",
                  "mn": "ADBE Vector Graphic - G-Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 3598,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 22,
          "ty": 2,
          "nm": "Layer 18",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.586], "y": [0.591] },
                  "o": { "x": [0.177], "y": [0] },
                  "t": 148,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.701], "y": [1] },
                  "o": { "x": [0.349], "y": [0.567] },
                  "t": 164,
                  "s": [-9.86]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 174,
                  "s": [-6]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 184,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 204,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 214,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 238,
                  "s": [-4]
                },
                { "t": 248, "s": [-20] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 148,
                  "s": [337, 450, 0],
                  "to": [7.583, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.581, "y": 1 },
                  "o": { "x": 0.396, "y": 0 },
                  "t": 155,
                  "s": [382.5, 450, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 164,
                  "s": [337, 450, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.417, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 170,
                  "s": [352.5, 450, 0],
                  "to": [3.417, 1.667, 0],
                  "ti": [-0.833, -3.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 184,
                  "s": [357.5, 460, 0],
                  "to": [0.833, 3.333, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 189,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 194,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 199,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 204,
                  "s": [357.5, 460, 0],
                  "to": [5.833, -8.792, 0],
                  "ti": [-5.833, 8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 214,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 218,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 223,
                  "s": [392.5, 417.25, 0],
                  "to": [0, -0.833, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 228,
                  "s": [392.5, 402.25, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 233,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 238,
                  "s": [392.5, 407.25, 0],
                  "to": [-5.833, 8.792, 0],
                  "ti": [5.833, -8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 248,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 254,
                  "s": [357.5, 460, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 259,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 264,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                { "t": 269, "s": [357.5, 460, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [387, 224, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 96.246, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 148,
          "op": 165,
          "st": 154,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 23,
          "ty": 4,
          "nm": "Shape Layer 16",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 204,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 214,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 238,
                  "s": [19]
                },
                { "t": 248, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 148,
                  "s": [347.5, 496, 0],
                  "to": [6.75, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.581, "y": 1 },
                  "o": { "x": 0.396, "y": 0 },
                  "t": 155,
                  "s": [388, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 164,
                  "s": [347.5, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.583, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 170,
                  "s": [358, 496, 0],
                  "to": [3.583, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 184,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 204,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 214,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 238,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                { "t": 248, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 184,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 189,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 194,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 199,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 218,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 223,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 228,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 233,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 254,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 259,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 264,
                  "s": [50, 68, 100]
                },
                { "t": 269, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 148,
          "op": 165,
          "st": 154,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 24,
          "ty": 4,
          "nm": "Shape Layer 15",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 204,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 214,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 238,
                  "s": [19]
                },
                { "t": 248, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 148,
                  "s": [347.5, 496, 0],
                  "to": [6.75, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.581, "y": 1 },
                  "o": { "x": 0.396, "y": 0 },
                  "t": 155,
                  "s": [388, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 164,
                  "s": [347.5, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.583, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 170,
                  "s": [358, 496, 0],
                  "to": [3.583, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 184,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 204,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 214,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 238,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                { "t": 248, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 184,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 189,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 194,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 199,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 218,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 223,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 228,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 233,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 254,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 259,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 264,
                  "s": [61, 79, 100]
                },
                { "t": 269, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 148,
          "op": 165,
          "st": 154,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 25,
          "ty": 2,
          "nm": "Layer 12",
          "refId": "image_3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 11,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 37,
                  "s": [-6]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.297], "y": [0] },
                  "t": 47,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.797], "y": [1] },
                  "o": { "x": [0.431], "y": [0] },
                  "t": 67,
                  "s": [-20]
                },
                {
                  "i": { "x": [0.632], "y": [1] },
                  "o": { "x": [0.158], "y": [0] },
                  "t": 77,
                  "s": [-4]
                },
                {
                  "i": { "x": [0.683], "y": [1] },
                  "o": { "x": [0.438], "y": [0] },
                  "t": 101,
                  "s": [-4]
                },
                { "t": 111, "s": [-20] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 11,
                  "s": [337, 450, 0],
                  "to": [7.583, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.93, "y": 1 },
                  "o": { "x": 0.728, "y": 0 },
                  "t": 18,
                  "s": [382.5, 450, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 27,
                  "s": [337, 450, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.417, -1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [352.5, 450, 0],
                  "to": [3.417, 1.667, 0],
                  "ti": [-0.833, -3.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 47,
                  "s": [357.5, 460, 0],
                  "to": [0.833, 3.333, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 52,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 57,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 62,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [357.5, 460, 0],
                  "to": [5.833, -8.792, 0],
                  "ti": [-5.833, 8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 77,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 81,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 86,
                  "s": [392.5, 417.25, 0],
                  "to": [0, -0.833, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 91,
                  "s": [392.5, 402.25, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.833, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 96,
                  "s": [392.5, 407.25, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [392.5, 407.25, 0],
                  "to": [-5.833, 8.792, 0],
                  "ti": [5.833, -8.792, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 111,
                  "s": [357.5, 460, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 117,
                  "s": [357.5, 460, 0],
                  "to": [0, 1.667, 0],
                  "ti": [0, 0.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 122,
                  "s": [357.5, 470, 0],
                  "to": [0, -0.417, 0],
                  "ti": [0, 1.667, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 127,
                  "s": [357.5, 457.5, 0],
                  "to": [0, -1.667, 0],
                  "ti": [0, -0.417, 0]
                },
                { "t": 132, "s": [357.5, 460, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [387, 224, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 96.246, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 11,
          "op": 27,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 26,
          "ty": 4,
          "nm": "Shape Layer 4",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [19]
                },
                { "t": 111, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 11,
                  "s": [347.5, 496, 0],
                  "to": [6.75, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.93, "y": 1 },
                  "o": { "x": 0.728, "y": 0 },
                  "t": 18,
                  "s": [388, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 27,
                  "s": [347.5, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.583, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [358, 496, 0],
                  "to": [3.583, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 77,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                { "t": 111, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 81,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 86,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [50, 68, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [50, 50, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [50, 0, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [50, 68, 100]
                },
                { "t": 132, "s": [50, 50, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 11,
          "op": 27,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 27,
          "ty": 4,
          "nm": "Shape Layer 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 67,
                  "s": [-7]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [19]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 101,
                  "s": [19]
                },
                { "t": 111, "s": [-7] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.833, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 11,
                  "s": [347.5, 496, 0],
                  "to": [6.75, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.93, "y": 1 },
                  "o": { "x": 0.728, "y": 0 },
                  "t": 18,
                  "s": [388, 496, 0],
                  "to": [0, 0, 0],
                  "ti": [5, 0, 0]
                },
                {
                  "i": { "x": 0.29, "y": 1 },
                  "o": { "x": 0.235, "y": 0 },
                  "t": 27,
                  "s": [347.5, 496, 0],
                  "to": [-5, 0, 0],
                  "ti": [-3.583, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [358, 496, 0],
                  "to": [3.583, 1.333, 0],
                  "ti": [-1.833, -1.333, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 47,
                  "s": [369, 504, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 67,
                  "s": [369, 504, 0],
                  "to": [4.125, -9.5, 0],
                  "ti": [-4.125, 10.417, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 77,
                  "s": [393.75, 447, 0],
                  "to": [4.125, -10.417, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 101,
                  "s": [393.75, 447, 0],
                  "to": [0, 0, 0],
                  "ti": [4.125, -9.5, 0]
                },
                { "t": 111, "s": [369, 504, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [44.5, 15, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 47,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 52,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 57,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 62,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 81,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 86,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 91,
                  "s": [61, 79, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 96,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 117,
                  "s": [61, 61, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 122,
                  "s": [61, 11, 100]
                },
                {
                  "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 127,
                  "s": [61, 79, 100]
                },
                { "t": 132, "s": [61, 61, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [15.602, 0],
                        [0, -15.602],
                        [-15.602, 0],
                        [0, 15.602]
                      ],
                      "o": [
                        [-15.602, 0],
                        [0, 15.602],
                        [15.602, 0],
                        [0, -15.602]
                      ],
                      "v": [
                        [0, -28.25],
                        [-28.25, 0],
                        [0, 28.25],
                        [28.25, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.75, 15.75], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 11,
          "op": 27,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 28,
          "ty": 4,
          "nm": "Glitter 4",
          "parent": 32,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 22, "ix": 10 },
            "p": { "a": 0, "k": [376.01, 104.21, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [35.185, 35.185, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501],
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501]
                      ],
                      "o": [
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501],
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501]
                      ],
                      "v": [
                        [0, -101.908],
                        [5.657, -5.657],
                        [101.908, 0],
                        [5.657, 5.657],
                        [0, 101.908],
                        [-5.657, 5.657],
                        [-101.908, 0],
                        [-5.657, -5.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 105,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 116.011,
                        "s": [100, 100]
                      },
                      { "t": 137.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 105,
                        "s": [0]
                      },
                      { "t": 137.0322265625, "s": [-10.677] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626],
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626]
                      ],
                      "o": [
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626],
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626]
                      ],
                      "v": [
                        [0, -149.103],
                        [9.899, -9.899],
                        [149.103, 0],
                        [9.899, 9.899],
                        [0, 149.103],
                        [-9.899, 9.899],
                        [-149.103, 0],
                        [-9.899, -9.899]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 105,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 121.016,
                        "s": [70, 70]
                      },
                      { "t": 137.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 105,
                        "s": [45]
                      },
                      { "t": 137.0322265625, "s": [12.968] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 105,
          "op": 138.033203125,
          "st": 105,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 29,
          "ty": 4,
          "nm": "Glitter 3",
          "parent": 32,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 22, "ix": 10 },
            "p": { "a": 0, "k": [357.467, 203.493, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [35.185, 35.185, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501],
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501]
                      ],
                      "o": [
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501],
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501]
                      ],
                      "v": [
                        [0, -101.908],
                        [5.657, -5.657],
                        [101.908, 0],
                        [5.657, 5.657],
                        [0, 101.908],
                        [-5.657, 5.657],
                        [-101.908, 0],
                        [-5.657, -5.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 51,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 62.011,
                        "s": [100, 100]
                      },
                      { "t": 83.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 51,
                        "s": [0]
                      },
                      { "t": 83.0322265625, "s": [-10.677] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626],
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626]
                      ],
                      "o": [
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626],
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626]
                      ],
                      "v": [
                        [0, -149.103],
                        [9.899, -9.899],
                        [149.103, 0],
                        [9.899, 9.899],
                        [0, 149.103],
                        [-9.899, 9.899],
                        [-149.103, 0],
                        [-9.899, -9.899]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 51,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 67.016,
                        "s": [70, 70]
                      },
                      { "t": 83.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 51,
                        "s": [45]
                      },
                      { "t": 83.0322265625, "s": [12.968] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 51,
          "op": 84.033203125,
          "st": 51,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 30,
          "ty": 4,
          "nm": "Glitter 2",
          "parent": 32,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 22, "ix": 10 },
            "p": { "a": 0, "k": [412.86, 116.95, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [23.185, 23.185, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501],
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501]
                      ],
                      "o": [
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501],
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501]
                      ],
                      "v": [
                        [0, -101.908],
                        [5.657, -5.657],
                        [101.908, 0],
                        [5.657, 5.657],
                        [0, 101.908],
                        [-5.657, 5.657],
                        [-101.908, 0],
                        [-5.657, -5.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 51,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 62.011,
                        "s": [100, 100]
                      },
                      { "t": 83.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 51,
                        "s": [0]
                      },
                      { "t": 83.0322265625, "s": [-10.677] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626],
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626]
                      ],
                      "o": [
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626],
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626]
                      ],
                      "v": [
                        [0, -149.103],
                        [9.899, -9.899],
                        [149.103, 0],
                        [9.899, 9.899],
                        [0, 149.103],
                        [-9.899, 9.899],
                        [-149.103, 0],
                        [-9.899, -9.899]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 51,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 67.016,
                        "s": [70, 70]
                      },
                      { "t": 83.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 51,
                        "s": [45]
                      },
                      { "t": 83.0322265625, "s": [12.968] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 51,
          "op": 84.033203125,
          "st": 51,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 31,
          "ty": 4,
          "nm": "Glitter ",
          "parent": 32,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 22, "ix": 10 },
            "p": { "a": 0, "k": [332.692, 101.816, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [23.185, 23.185, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501],
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501]
                      ],
                      "o": [
                        [0, 0],
                        [5.501, 5.501],
                        [0, 0],
                        [-5.501, 5.501],
                        [0, 0],
                        [-5.501, -5.501],
                        [0, 0],
                        [5.501, -5.501]
                      ],
                      "v": [
                        [0, -101.908],
                        [5.657, -5.657],
                        [101.908, 0],
                        [5.657, 5.657],
                        [0, 101.908],
                        [-5.657, 5.657],
                        [-101.908, 0],
                        [-5.657, -5.657]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 20,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 31.011,
                        "s": [100, 100]
                      },
                      { "t": 52.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 20,
                        "s": [0]
                      },
                      { "t": 52.0322265625, "s": [-10.677] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626],
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626]
                      ],
                      "o": [
                        [0, 0],
                        [9.626, 9.626],
                        [0, 0],
                        [-9.626, 9.626],
                        [0, 0],
                        [-9.626, -9.626],
                        [0, 0],
                        [9.626, -9.626]
                      ],
                      "v": [
                        [0, -149.103],
                        [9.899, -9.899],
                        [149.103, 0],
                        [9.899, 9.899],
                        [0, 149.103],
                        [-9.899, 9.899],
                        [-149.103, 0],
                        [-9.899, -9.899]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 20,
                        "s": [0, 0]
                      },
                      {
                        "i": { "x": [0.51, 0.51], "y": [1, 1] },
                        "o": { "x": [0.49, 0.49], "y": [0, 0] },
                        "t": 36.016,
                        "s": [70, 70]
                      },
                      { "t": 52.0322265625, "s": [0, 0] }
                    ],
                    "ix": 3
                  },
                  "r": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 20,
                        "s": [45]
                      },
                      { "t": 52.0322265625, "s": [12.968] }
                    ],
                    "ix": 6
                  },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Polystar 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 20,
          "op": 53.033203125,
          "st": 20,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 32,
          "ty": 2,
          "nm": "Layer 2",
          "refId": "image_4",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 77,
                  "s": [-22]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 87,
                  "s": [13]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 97,
                  "s": [-24]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 107,
                  "s": [13]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.167], "y": [0] },
                  "t": 117,
                  "s": [-24]
                },
                {
                  "i": { "x": [0.667], "y": [1] },
                  "o": { "x": [0.333], "y": [0] },
                  "t": 127,
                  "s": [13]
                },
                { "t": 137, "s": [-22] }
              ],
              "ix": 10
            },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 17,
                  "s": [452.725, 554.372, 0],
                  "to": [-30, 0, 0],
                  "ti": [28.333, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 33,
                  "s": [272.725, 554.372, 0],
                  "to": [-28.333, 0, 0],
                  "ti": [-1.667, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.167, "y": 0.167 },
                  "t": 47,
                  "s": [282.725, 554.372, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 67,
                  "s": [282.725, 554.372, 0],
                  "to": [0, -23.333, 0],
                  "ti": [-7.19, 18.617, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 77,
                  "s": [282.725, 414.372, 0],
                  "to": [7.19, -18.617, 0],
                  "ti": [3.836, 4.212, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 87,
                  "s": [325.863, 442.671, 0],
                  "to": [-3.836, -4.212, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 97,
                  "s": [259.706, 389.098, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 107,
                  "s": [325.863, 442.671, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 117,
                  "s": [259.706, 389.098, 0],
                  "to": [0, 0, 0],
                  "ti": [-3.836, -27.546, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 127,
                  "s": [325.863, 442.671, 0],
                  "to": [3.836, 27.546, 0],
                  "ti": [-21.144, -18.617, 0]
                },
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.167, "y": 0 },
                  "t": 137,
                  "s": [282.725, 554.372, 0],
                  "to": [21.144, 18.617, 0],
                  "ti": [-28.333, 0, 0]
                },
                { "t": 148, "s": [452.725, 554.372, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [337.172, 216.195, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 17,
          "op": 148,
          "st": 17,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 33,
          "ty": 0,
          "nm": "Comp 1",
          "refId": "comp_1",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [506, 432, 0], "ix": 2 },
            "a": { "a": 0, "k": [250, 250, 0], "ix": 1 },
            "s": { "a": 0, "k": [139, 139, 100], "ix": 6 }
          },
          "ao": 0,
          "w": 500,
          "h": 500,
          "ip": 78,
          "op": 537,
          "st": 78,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_1",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 0,
          "nm": "Comp 1",
          "refId": "comp_2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [250, 130, 0], "ix": 2 },
            "a": { "a": 0, "k": [360, 300, 0], "ix": 1 },
            "s": { "a": 0, "k": [67, 67, 100], "ix": 6 }
          },
          "ao": 0,
          "w": 720,
          "h": 600,
          "ip": 0,
          "op": 61.0610610610611,
          "st": 0,
          "bm": 0
        }
      ]
    },
    {
      "id": "comp_2",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "pang 7",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [178, 335, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.628, 0.628, 0.694], "y": [1, 1, 1] },
                  "o": { "x": [0.202, 0.202, 0.171], "y": [0.231, 0.231, 0] },
                  "t": 26.026,
                  "s": [0, 0, 100]
                },
                { "t": 46.046046046046, "s": [141.594, 141.594, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.945098039216, 0.074866605272, 0.279626913632, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 26.026,
                        "s": [20]
                      },
                      { "t": 46.046046046046, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 3, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 13, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 26.026026026026,
          "op": 326.326326326326,
          "st": 26.026026026026,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "pang 3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [467, 264, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 34.034,
                  "s": [0, 0, 100]
                },
                { "t": 54.0540540540541, "s": [162.515, 162.515, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.43137254902, 0.712341308594, 1, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 34.034,
                        "s": [20]
                      },
                      { "t": 54.0540540540541, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 2, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 10, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 34.034034034034,
          "op": 334.334334334334,
          "st": 34.034034034034,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 4,
          "nm": "line 4",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [780, 300, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-341, 39.5],
                        [-314, -34.5]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 22.022,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 28.028,
                        "s": [61]
                      },
                      { "t": 34.034034034034, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 18.018,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.144], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 22.022,
                        "s": [33]
                      },
                      { "t": 28.028028028028, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.43137255311, 0.917647063732, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 18.018018018018,
          "op": 318.318318318318,
          "st": 18.018018018018,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "pang 6",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [334, 230, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 30.03,
                  "s": [0, 0, 100]
                },
                { "t": 50.05005005005, "s": [98.254, 98.254, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.050580540825, 0.108183176377, 0.992156862745, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 30.03,
                        "s": [20]
                      },
                      { "t": 50.05005005005, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 1, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 10, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 30.03003003003,
          "op": 330.33033033033,
          "st": 30.03003003003,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "pang 8",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [497, 342, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 23.023,
                  "s": [0, 0, 100]
                },
                { "t": 43.043043043043, "s": [113.717, 113.717, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.969227390663, 0.43137254902, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 23.023,
                        "s": [24]
                      },
                      { "t": 43.043043043043, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 2, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 13, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 23.023023023023,
          "op": 323.323323323323,
          "st": 23.023023023023,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "pang 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [279, 243, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 26.026,
                  "s": [0, 0, 100]
                },
                { "t": 46.046046046046, "s": [157.998, 157.998, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.060392260084, 1, 0.219573301428, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 26.026,
                        "s": [24]
                      },
                      { "t": 46.046046046046, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 2.5, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 15, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": -8, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 26.026026026026,
          "op": 326.326326326326,
          "st": 26.026026026026,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 4,
          "nm": "line 3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [637, 300, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-333.5, 37.5],
                        [-357, -57]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 14.014,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 20.02,
                        "s": [61]
                      },
                      { "t": 26.026026026026, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 10.01,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.144], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 14.014,
                        "s": [33]
                      },
                      { "t": 20.02002002002, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.43137255311, 0.917647063732, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 10.01001001001,
          "op": 310.31031031031,
          "st": 10.01001001001,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "pang 5",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [545, 228, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 22.022,
                  "s": [0, 0, 100]
                },
                { "t": 42.042042042042, "s": [128.929, 128.929, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.690934603822, 0.43137254902, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 22.022,
                        "s": [20]
                      },
                      { "t": 42.042042042042, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 1, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 10, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 22.022022022022,
          "op": 322.322322322322,
          "st": 22.022022022022,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "pang",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [622, 277, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 20.02,
                  "s": [0, 0, 100]
                },
                { "t": 40.04004004004, "s": [198.981, 198.981, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.546986239564, 0.223823502484, 0.690980440028, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 20.02,
                        "s": [20]
                      },
                      { "t": 40.04004004004, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 1, "ix": 1 }
                    },
                    { "n": "g", "nm": "gap", "v": { "a": 0, "k": 9, "ix": 2 } },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 8, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 20.02002002002,
          "op": 320.32032032032,
          "st": 20.02002002002,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 10,
          "ty": 4,
          "nm": "line 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [697, 300, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-168.5, 75],
                        [-74.212, -24.5]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 8.008,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 14.014,
                        "s": [61]
                      },
                      { "t": 20.02002002002, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 4.004,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.144], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 8.008,
                        "s": [33]
                      },
                      { "t": 14.014014014014, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.43137255311, 0.917647063732, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 4, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 4.004004004004,
          "op": 304.304304304304,
          "st": 4.004004004004,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "pang 4",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [153, 228, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 20.02,
                  "s": [0, 0, 100]
                },
                { "t": 40.04004004004, "s": [128.929, 128.929, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [0.985882329006, 0.934848501168, 0.978491270776, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 20.02,
                        "s": [20]
                      },
                      { "t": 40.04004004004, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 1, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 20, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 4, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 20.02002002002,
          "op": 320.32032032032,
          "st": 20.02002002002,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 12,
          "ty": 4,
          "nm": "pang",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [98, 270, 0], "ix": 2 },
            "a": { "a": 0, "k": [-247, -52, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0, 0, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.167, 0.167, 0.167], "y": [0.167, 0.167, 0] },
                  "t": 16.016,
                  "s": [0, 0, 100]
                },
                { "t": 36.036036036036, "s": [150.378, 150.378, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [76.756, 76.756], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.43137255311, 0.917647063732, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 16.016,
                        "s": [20]
                      },
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 24.024,
                        "s": [10]
                      },
                      { "t": 36.036036036036, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "d": [
                    {
                      "n": "d",
                      "nm": "dash",
                      "v": { "a": 0, "k": 2, "ix": 1 }
                    },
                    {
                      "n": "g",
                      "nm": "gap",
                      "v": { "a": 0, "k": 20, "ix": 2 }
                    },
                    {
                      "n": "o",
                      "nm": "offset",
                      "v": { "a": 0, "k": 0, "ix": 7 }
                    }
                  ],
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [-246.987, -54.648], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [132.861, 132.861], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Ellipse 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 16.016016016016,
          "op": 316.316316316316,
          "st": 16.016016016016,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 13,
          "ty": 4,
          "nm": "line",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [360, 300, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-176, 75],
                        [-260, -30]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.667], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 4.004,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.333], "y": [0] },
                        "t": 10.01,
                        "s": [61]
                      },
                      { "t": 16.016016016016, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 0,
                        "s": [0]
                      },
                      {
                        "i": { "x": [0.144], "y": [1] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 4.004,
                        "s": [33]
                      },
                      { "t": 10.01001001001, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": {
                    "a": 0,
                    "k": [1, 0.43137255311, 0.917647063732, 1],
                    "ix": 3
                  },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 4, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 300.3003003003,
          "st": 0,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 0,
      "nm": "vin-with-phn",
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [500, 638, 0], "ix": 2 },
        "a": { "a": 0, "k": [500, 500, 0], "ix": 1 },
        "s": { "a": 0, "k": [145, 145, 100], "ix": 6 }
      },
      "ao": 0,
      "w": 1000,
      "h": 1000,
      "ip": 0,
      "op": 18459,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
